<div class="container-fluid d-none d-md-block mt-3">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item hcm-breadcrumb-text">
                <a routerLink="/home">{{ 'stepper.home' | translate }}</a>
            </li>
            <li class="breadcrumb-item active hcm-breadcrumb-text" aria-current="page">
                {{ 'header.closedHotCall' | translate }}
            </li>
        </ol>
    </nav>
</div>
<div class="container-fluid">
    <h4 class="d-flex align-items-center mx-1 pb-2 mt-2 gap-2">
        <img src="../../../../../assets/img/Icon.svg" alt="Back Icon" class="float-left me-2 cu"
            (click)="backToHome()" />
        <span class="hcm-nav-text">{{ 'activeHotCalls.title2' | translate }}</span>
    </h4>
    <form [formGroup]="closedHotcallForm" class="row d-flex flex-wrap mb-1">
        <div class="col-12 d-flex align-items-center mb-md-2 cu flex-wrap">
            <div class="col-5 col-md-2 d-flex align-items-center mb-2 mb-md-0 px-1">
                <input type="text" formControlName="searchQuery"
                    [placeholder]="'activeHotCalls.search.ticket' | translate"
                    class="search-kanban me-1 pe-1 ps-0 w-100">
                <img src="../../../../../assets/img/search-icon.svg" alt="Search icon" class="float-right me-2">
            </div>
            <div class="col-7 col-md-2 px-2 mb-md-0">
                <mat-select formControlName="selectedStatus" class="w-100">
                    <mat-option value="" disabled hidden>{{ 'closedHotCalls.status.select' | translate }}</mat-option>
                    <mat-option *ngFor="let status of statusOptions" [value]="status" [hidden]="!status">
                        {{getStatus(status.toLowerCase().replace(' ', '') | translate)}}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-12 col-md-8 d-flex justify-content-end justify-content-md-end align-items-center mb-md-0">
                <span class="hcm-label mb-0 text-center text-md-end d-flex flex-nowrap align-items-center">
                    Sort by Create DT:
                    <img src="../../../../../assets/img/sort.svg" alt="Sort Icon" class="sort-icon pb-1 px-2"
                        (click)="toggleSortOrder()" [matTooltip]="sortState" />
                </span>
            </div>
        </div>
        <div *ngIf="filteredHotCalls.length > 0">
            <div class="virtual-scroll-container-wrapper">
                <cdk-virtual-scroll-viewport itemSize="120" class="virtual-scroll-container" [minBufferPx]="100"
                    [maxBufferPx]="200">
                    <div *cdkVirtualFor="let closedHotCall of filteredHotCalls" class="mt-1">
                        <div appearance="outlined" class="mat-elevation-z4">
                            <div class="hot-call-top-border d-flex flex-wrap align-items-center col-12 pt-2 pb-2">
                                <!-- Ticket ID -->
                                <p class="col-7 col-md-2 mb-0 hcm-ticket-id-value text-md-start ps-3">
                                    {{closedHotCall.ticketId}}
                                </p>

                                <!-- Status -->
                                <span
                                    class="col-5 col-md-2 ps-md-2 mb-0 hcm-status-value text-md-start ms-md-2 hot-call-open-top-border"
                                    [ngClass]="getHotCallStatus(getStatus(closedHotCall.ticketStatus))">
                                    {{getStatus(closedHotCall.ticketStatus.toLowerCase().replace(' ', '') | translate)}}
                                </span>
                            </div>
                            <mat-card-content>
                                <div class="row p-3 pb-0 mb-2">
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{ 'activeHotCalls.ticketDetails.seqScan' | translate
                                            }}
                                            <br><span class="hcm-value-text">{{closedHotCall.seqScan}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{ 'activeHotCalls.ticketDetails.body' | translate }}
                                            <br><span class="hcm-value-text">{{closedHotCall.body}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{ 'activeHotCalls.ticketDetails.pcsRem' | translate
                                            }}
                                            <br><span class="hcm-value-text">{{closedHotCall.pcsRem}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{ 'activeHotCalls.ticketDetails.firstMissedSeq' |
                                            translate }}
                                            <br><span class="hcm-value-text">{{closedHotCall.firMsdSeq}}</span>
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <p class="hcm-label mb-2">{{ 'activeHotCalls.ticketDetails.initialVehicles' |
                                            translate }}
                                            <br><span class="hcm-value-text">{{closedHotCall.intVhcleEmpty}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{ 'activeHotCalls.ticketDetails.sp' | translate }}
                                            <br><span class="hcm-value-text">{{closedHotCall.sp}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{ 'activeHotCalls.ticketDetails.kb' | translate }}
                                            <br><span class="hcm-value-text">{{closedHotCall.kb}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{ 'activeHotCalls.ticketDetails.lmn' | translate }}
                                            <br><span class="hcm-value-text">{{closedHotCall.lineNm}}</span>
                                        </p>
                                    </div>
                                    <div class="col-6 col-md-2">
                                        <p class="hcm-label mb-2">{{ 'activeHotCalls.ticketDetails.dk' | translate }}
                                            <br><span class="hcm-value-text">{{closedHotCall.dk}}</span>
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <p class="hcm-label mb-2">{{ 'activeHotCalls.ticketDetails.createdBy' |
                                            translate }}
                                            <br><div class="d-flex flex-md-column"><span class="me-3 hcm-value-text">{{closedHotCall.crteBy}}</span>
                                                <span class="me-3 hcm-value-text">{{closedHotCall.crteOn  | date: 'MM/dd/yyyy hh:mm a' }}</span></div>
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-2">
                                        <p class="hcm-label mb-2">{{ 'activeHotCalls.ticketDetails.lastModified' |
                                            translate
                                            }}
                                            <br><div class="d-flex flex-md-column"><span class="me-3 hcm-value-text">{{closedHotCall.updtBy }}</span>
                                                <span class="me-3 hcm-value-text">{{closedHotCall.updtOn  | date: 'MM/dd/yyyy hh:mm a' }}</span></div>
                                        </p>
                                    </div>
                                </div>
                            </mat-card-content>
                        </div>
                    </div>
                </cdk-virtual-scroll-viewport>
            </div>
        </div>
        <div *ngIf="!isLoading && filteredHotCalls.length == 0">
            <div class="d-flex justify-content-center align-items-center mt-5">
                <p>No Data available</p>
            </div>
        </div>
    </form>
</div>